import { render, staticRenderFns } from "./FictitiousBookingsList.vue?vue&type=template&id=ea1ed8e2&"
import script from "./FictitiousBookingsList.vue?vue&type=script&lang=js&"
export * from "./FictitiousBookingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports